/**
 * Enmascarado de destino para las pantallas de verificación — correo y teléfono.
 * Un solo lugar para las dos reglas, usadas por VerifyEmailForm y VerifyPhoneForm.
 */

/** `javier.botello@abakoo.mx` → `jav***@abakoo.mx`; siempre oculta parte del usuario. */
export function maskEmail(email: string): string | null {
  const atIndex = email.indexOf('@')
  if (atIndex <= 0 || atIndex === email.length - 1) return null
  const user = email.slice(0, atIndex)
  const domain = email.slice(atIndex)
  const visible = user.slice(0, Math.min(3, user.length - 1))
  return `${visible}***${domain}`
}

/** `5512345678` → `5678`; se guarda solo este sufijo durante el registro. */
export function getPhoneLast4(phoneNumber: string): string | null {
  const digits = phoneNumber.replace(/\D/g, '')
  if (digits.length < 4) return null
  return digits.slice(-4)
}

/** Lada visible y solo el sufijo del teléfono: `+52 *** *** 6046`. */
export function maskPhoneTail(
  countryCode: string | null,
  phoneLast4: string | null,
): string | null {
  if (
    !countryCode ||
    !/^\+\d{1,4}$/.test(countryCode) ||
    !phoneLast4 ||
    !/^\d{4}$/.test(phoneLast4)
  ) {
    return null
  }
  return `${countryCode} *** *** ${phoneLast4}`
}
